/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="https://crm-1304146125.cos.ap-beijing.myqcloud.com/a1m6p9f2g2f6b9m0d3e4g2t1u62" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.id" :index="menu.id">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{ menu.name }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.children" :index="'/' + chmenu.url" :key="chmenu.id">
          <i :class="chmenu.icon"></i>
          <span>{{ chmenu.name }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { getListByUser } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [],
      roleId: "",
      userlist: ""
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    getListByUser().then(res => {

      if (res.code == 0) {
        this.allmenu = res.data

      } else {

        this.$router.push({ path: '/login' })
        return
      }
    })
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {

  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;

}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}

.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue